import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../shared/http.service';
import { ActivatedRoute, Params } from '@angular/router';
import moment = require('moment');
import { AlertService } from '../../../shared/alert.service';

@Component({
  selector: 'app-list-members',
  templateUrl: './list-members.component.html',
  styleUrls: ['./list-members.component.scss']
})
export class ListMembersComponent implements OnInit {
  hasDataTables = true;
  membersReady = false;
  actions = true;
  prevPath = '../';
  listId: string;
  members = {};
  entity = 'mailchimp/list';


  // [api param, column name, isSortable]
  columns = [
    ['email_address', 'Correo electrónico', false], // userid.instituteName
    ['status', 'Status', false], // userid.contactName
    ['member_rating', 'Rating', false],
    ['avg_open_rate', 'Ratio aperturas', false],
    ['avg_click_rate', 'Ratio clicks', false],
    ['last_changed', 'Ultimo cambio', false]
  ];

  // [name, table header, isVisible]
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];

  msg = {
    'delete': 'Suscriptor borrado exitosamente',
    'error': 'Ocurrió un error inesperado'
  };

  constructor(private httpService: HttpService,
              private alertService: AlertService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['listId']) {
        this.listId = params['listId'];
        this.getAllMembers();
      }
    });
  }

  getAllMembers() {
    this.httpService.getRaw('/MailChimp/List/' + this.listId + '/Members', [])
      .subscribe(
        membersResponse => {
          this.members['objects'] = [];
          for (let member of membersResponse['members']) {
            let item = {};
            item['id'] = member['id'];
            item['email_address'] = member.email_address;
            item['status'] = member.status;
            item['member_rating'] = member.member_rating;
            item['avg_click_rate'] = member['stats']['avg_click_rate'];
            item['avg_open_rate'] = member['stats']['avg_open_rate'];
            item['last_changed'] = moment(member.last_changed).format('DD/MM/YYYY HH:mm');
            this.members['objects'].push(item);
          }
          this.members['length'] = membersResponse['total_items'];
          this.members['pagination'] = 100;
          this.members['offset'] = 0;
          this.entity = 'mailchimp/list/' + this.listId + '/edit';
          this.membersReady = true;
        }
      );
  }

  delete(value) {
    this.membersReady = false;
    this.httpService.delete('/MailChimp/List/' + this.listId + '/Members/', value)
      .subscribe(
        updateResponse => {
          this.getAllMembers();
          this.alertService.success(this.msg['delete']);
        },
        error => {
          this.alertService.error(this.msg['error']);
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/mailchimp/list/list-members/list-members.component.ts